<div class="flex gap-3">
  <!-- @for (option of languageOptions; track option.value; let i = $index) {
    <div
      class="flex justify-content-center align-items-center gap-3 border-1 border-200 border-round-xl cursor-pointer lang-btn
    {{ langSelected() === option.value ? 'lang-btn-active' : '' }}"
      style="padding: 12px 16px"
      (click)="onSelectLang(option.value)"
      (keyup.enter)="onSelectLang(option.value)"
      tabindex="0"
    >
      <img class="w-2rem" [src]="option.img_path" alt="img_logo_{{ option.label }}" />
      <p class="text-sm font-normal">{{ option.label }}</p>
    </div>
  } -->

  <p-select
    [options]="languageOptionsDropdown"
    [(ngModel)]="selectedLanguage"
    optionLabel="label"
    placeholder="Select a Language"
    (onChange)="onChangeLangDropdown($event)"
  >
    <ng-template pTemplate="selectedItem">
      @if (selectedLanguage()) {
        <div class="flex align-items-center gap-2">
          <img [src]="selectedLanguage().img_path" style="width: 18px" alt="img_logo_{{ selectedLanguage().label }}" />
          <div>{{ selectedLanguage().label }}</div>
        </div>
      }
    </ng-template>
    <ng-template let-lang pTemplate="item">
      <div class="flex align-items-center gap-2">
        <img [src]="lang.img_path" style="width: 18px" alt="img_logo_{{ lang.label }}" />
        <div>{{ lang.label }}</div>
      </div>
    </ng-template>
  </p-select>
</div>
